import React from "react"

interface ConfirmationItem {
   order: number,
   boldText: string,
   text: string,
}

interface ConfirmationAction {
   href: string,
   text: string
}

interface DefaultConfirmationData {
   title: string,
   list: ConfirmationItem[],
   action: ConfirmationAction,
}

interface DefaultConfirmationProps {
   data: DefaultConfirmationData
}

export const DefaultConfirmation: React.FC<DefaultConfirmationProps> = ({ data }) => {
   const showSupportChat = (e: React.SyntheticEvent) => {
      e.preventDefault();
      LSHelper.HelperLib.openSupportChat();
   }
   return <div className="leadcapturelp-confirmation-default">
      <h2 className="leadcapturelp-confirmation-default-title">{data.title}</h2>
      <div className="leadcapturelp-confirmation-default-list">
         {data.list.map((item, index) => <div key={index} className="leadcapturelp-confirmation-default-item">
            <div className="leadcapturelp-confirmation-default-item-number"><div>{item.order}</div></div>
            <div className="leadcapturelp-confirmation-default-item-text"><span>{item.boldText}</span> {item.text}</div>
         </div>)}
      </div>
      <div className="leadcapturelp-confirmation-default-actions">
         <a href={data.action.href} className="btn btn-sm btn-primary-on-dark">{data.action.text}</a>
         <a href="#" onClick={showSupportChat} className="btn btn-sm btn-secondary-on-dark">Contact Support</a>
      </div>
   </div>
}